import * as React from "react";

import {cs}             from "@Common/react/chain-services";
//import "./user-assets-layout.scss";
import {consumeContext} from "@Common/react/context";

import {AccountTabsLayout} from "../../../common/account-tabs-layout/account-tabs-layout";

export const AccountingLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    ({accountMenu}, next) => AccountTabsLayout({
        activeMenu: "accounting",
        activeTab,
        config: (() => {
            const accountingMenu = accountMenu?.adminDropdownMenu?.dropdownItems?.find((m) => m.configPath === "accountingMenu");
            return !accountingMenu?.subMenu ? (
                items
            ) : (
                accountingMenu.subMenu.map((m) => {
                    const rename = items.find((m1) => m1.name === m.name)?.rename;
                    return !rename ? m : {...m, linkLabel: rename(m.linkLabel)};
                })
            );
        })(),
        next,
    }),
    () => (
        <div className="accounting-layout-i8i">
            {next()}
        </div>
    ),
);

const items = [
    {
        linkLabel: "Vouchers",
        name: "admin-vouchers",
        link: "/account/admin/accounting/vouchers",
    },
    {
        linkLabel: "Ad Budget Defaults",
        name: "ad-budget-defaults",
        link: "/account/admin/accounting/ad-budget-defaults",
    },
    {
        linkLabel: "User Ad Budgets",
        name: "admin-ad-budgets",
        link: "/account/admin/accounting/ad-budgets",
        rename: (label) => label === "Ad Budgets" ? "User Ad Budgets" : label,
    },
];
